module.exports = __webpack_public_path__ + "img/meso_panza_verde.ed69255e.png";